import { Icon } from '@iconify/react';
import { alpha, Box, Button, Container, Grid, Paper, Stack, styled, Typography } from '@mui/material';
import { m } from 'framer-motion';
import React from 'react';

import TextMaxLine from '../../components/TextMaxLine';
import { varFade } from '../../components/animate';
import { useAppContext } from '../../contexts/AppContext';
import EventDialog from '../../components/EventDialog';
import useToggle from '../../hooks/useToggle';
import useEvents from '../../hooks/useEvents';
import LoadingView from '../../components/LoadingView';

const rowPerPage = 3;

const CardStyle = styled(Paper)(() => ({
  border: 0,
  borderRadius: 30,
  height: 500,
  margin: 'auto',
  boxShadow: `-20px 20px 40px 0 ${alpha('#000', 0.3)}`,
}));

const ButtomStyle = styled(Button)(({ theme }) => ({
  color: '#FFF',
  borderRadius: 35,
  fontSize: 18,
  backgroundImage: `linear-gradient(90deg, ${theme.palette.primary.main} , ${theme.palette.info.main} 200% )`,
}));

export default function HomeEvent() {
  const { events, loading } = useEvents();

  const { handleOpen } = useAppContext();

  return (
    <Stack width={1} py={5}>
      <Container>
        <Stack width={1} spacing={{ xs: 2, md: 7 }} alignItems="center">
          <Stack direction="row" spacing={1.5} width={1} alignItems="center" justifyContent="center">
            <Box height={2} width={1} bgcolor="#000" />

            <Typography fontWeight="bold" fontSize={28} px={1} whiteSpace="nowrap">
              À la une
            </Typography>

            <Box height={2} width={1} bgcolor="#000" />
          </Stack>

          {loading ? (
            <Stack width={1} height="70vh" alignItems="center" justifyContent="center">
              <LoadingView />
            </Stack>
          ) : (
            <Grid container rowSpacing={4} columnSpacing={{ xs: 0, md: 5, sm: 2 }}>
              {events.slice(0, rowPerPage).map((event) => (
                <Grid item component={m.div} variants={varFade().inLeft} key={event.title} xs={12} sm={6} md={4}>
                  <CardItem item={event} />
                </Grid>
              ))}
            </Grid>
          )}

          <Stack>
            <ButtomStyle onClick={handleOpen} sx={{ px: 5, py: 2 }}>
              Recevez les actualités et opportunités d'investissement
            </ButtomStyle>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
}

const CardItem = ({ item }) => {
  const { url = '', title, description: desc, date, location } = item;
  const { toggle, onOpen, onClose } = useToggle();
  return (
    <>
      <CardStyle
        elevation={12}
        onClick={onOpen}
        sx={{
          cursor: 'pointer',
          maxWidth: { xs: 1, md: 400 },
          ':hover': { textDecoration: 'underline', textDecorationColor: 'text.primary' },
        }}
      >
        <Stack height={1} justifyContent="space-between">
          <Stack minHeight={260}>
            <Box
              component="img"
              src={url}
              height="auto"
              borderRadius="30px 30px 0 0"
              sx={{ aspectRatio: 'unset', objectFit: 'contain' }}
            />
          </Stack>

          <Stack
            p={1.5}
            height={1}
            justifyContent="space-between"
            sx={{ bgcolor: '#FFF', borderRadius: '0 0 30px 30px' }}
          >
            <TextMaxLine line={2} variant="h4" color="primary.main">
              {title}
            </TextMaxLine>

            <TextMaxLine variant="body1" fontSize={17} line={3}>
              {desc}
            </TextMaxLine>
            <Stack width={1} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              <Stack direction="row" spacing={2}>
                <Icon icon="bxs:calendar" />
                <Typography> {date} </Typography>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Icon icon="grommet-icons:map-location" />
                <Typography> {location} </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </CardStyle>
      <EventDialog item={{ ...item, desc }} open={toggle} onClose={onClose} />
    </>
  );
};
